import React, { HTMLAttributes } from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { getHorseAgeSexColorValue } from "utils/horse";
import TableCellWrapper from "components/VetExamsTable/TableCellWrapper";

interface IProps extends HTMLAttributes<HTMLDivElement> {
  bold?: boolean;
  horse: racehorse360.IHorse;
}

const CsaCell = (props: IProps) => {
  const { horse, ...restProps } = props;

  return (
    <TableCellWrapper {...restProps} centered>
      {getHorseAgeSexColorValue(horse)}
    </TableCellWrapper>
  );
};

export default React.memo(CsaCell);
